import { PRODUCT_TYPES } from 'services/ProductTypeState'
import type { PhotoBankStore } from 'stores/photoBankStore/PhotoBankStore'
import type { PhotoBooksStore } from 'stores/photoBooksStore/PhotoBooksStore'
import type { TilesStore } from 'stores/tilesStore/TilesStore'
import {
  CART_SCHEMA_VERSION,
  type BaseCartMetadata,
  type CartItem,
} from '../CartItem'
import type {
  CartItemAdapter,
  CartItemAdapterMap,
} from './CartItemAdapter.types'
import { createPhotoBookCartItemAdapter } from './PhotoBookCartItemAdapter/PhotoBookCartItemAdapter'
import { createTilesCartItemAdapter } from './TilesCartItemAdapter/TilesCartItemAdapter'

type AdaptersDependencies = {
  tilesStore: TilesStore
  photoBooksStore: PhotoBooksStore
  photoBankStore: PhotoBankStore
}

export function createBaseCartMetadata(): BaseCartMetadata {
  return {
    version: CART_SCHEMA_VERSION,
    updatedAt: Date.now(),
  }
}

export function adapterFor<TItem extends CartItem>(
  adapters: CartItemAdapterMap,
  item: TItem
): CartItemAdapter<TItem> {
  const adapter = adapters[item.productType]
  if (!adapter) {
    throw new Error(
      `Missing cart adapter for product type: ${item.productType}`
    )
  }
  return adapter as CartItemAdapter<TItem>
}

export function createCartItemAdapters({
  tilesStore,
  photoBooksStore,
  photoBankStore,
}: AdaptersDependencies): CartItemAdapterMap {
  return {
    [PRODUCT_TYPES.CLASSIC]: createTilesCartItemAdapter(tilesStore),
    [PRODUCT_TYPES.PHOTO_BOOK]: createPhotoBookCartItemAdapter({
      photoBooksStore,
      photoBankStore,
    }),
  }
}
